<div class="text-center p-4 w-full 2xl:w-3/4 lg:w-11/12 m-auto">
  <h3 class="font-poppins font-extrabold text-2xl pt-9">Querido.a amante da língua francesa,</h3>
  <div class="text-xl leading-7 tracking-wide text-[#212529CC] w-10/12 m-auto">
    <p class="pt-6">
      Se você planeja uma viagem à França, quer realizar um intercâmbio lá, ter
      mais oportunidades de trabalho aqui no Brasil ou até mesmo na França...
    </p>
    <p class="pt-6">
      Se você quer falar francês em 2022, mas não tem ideia de por onde começar...
    </p>
    <p class="pt-6">
      Se você está cansado.a de procrastinar seus estudos por falta de rotina ou
      de uma mentora que te guie...
    </p>
    <p class="pt-6">
      Se você quer aprender a se expressar em francês com a pronúncia correta e
      seguindo um método claro, leve, dinâmico e prático...
    </p>
    <p class="pt-6 font-bold italic">Então você chegou ao lugar certo!</p>
    <p class="pt-6">
      No curso <strong>Francês em 3 Meses</strong> eu vou te ensinar o método mão na massa para
      você aprender a se comunicar em francês com uma boa pronúncia, mesmo que
      você nunca tenha estudado ou ache uma língua difícil.
    </p>

  </div>
</div>
